var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb-flash-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.94101 18.3638C7.64391 17.0912 6.30412 16.0495 5.75395 15.363C4.65645 13.9935 4 12.2553 4 10.3638C4 5.94549 7.58172 2.36377 12 2.36377C16.4183 2.36377 20 5.94549 20 10.3638C20 12.2563 19.3428 13.9953 18.2443 15.3652C17.6944 16.0508 16.3558 17.0914 16.059 18.3638H7.94101ZM16 20.3638V21.3638C16 22.4684 15.1046 23.3638 14 23.3638H10C8.89543 23.3638 8 22.4684 8 21.3638V20.3638H16ZM13 10.3686V6.36377L8.5 12.3686H11V16.3686L15.5 10.3686H13Z",
    fill: "#5784F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.d76d9900cfcc52733892b86bc6e3bac4.svg";
export { ForwardRef as ReactComponent };